import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getTransactionList, updateTransactionList} from '../../services/TransactionService'

interface GetTransactionListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface TransactionState {
  TransactionList: any
}

const initialState: TransactionState = {
  TransactionList: '',
}

// Fetch transaction list
export const getTransactionListApi = createAsyncThunk(
  'transaction/getTransactionList',
  async ({pageNumber, pageSize, filterkey}: GetTransactionListParams, {rejectWithValue}) => {
    try {
      const result = await getTransactionList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)
export const postTransactionApi = createAsyncThunk(
  'transaction/postTransactionList',
  async ({id,data}:{id:any,data:any}, {rejectWithValue}) => {
    try {
      const result = await updateTransactionList(id,data)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)
const TransactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getTransactionListApi.fulfilled, (state, action) => {
      state.TransactionList = action.payload
    })
  },
})

export default TransactionSlice
